interface IRouteBasic {
  name: string;
  path: string;
  pathToRegexpOptions?: { strict: boolean };
  component: () => void;
}

export interface IChildrenRouteStructure extends IRouteBasic{
  shouldDisabled?: boolean | ((T) => boolean);
}

export interface IRouteStructure extends IRouteBasic {
  redirect?: {name: string; path?: string};
  children?: IChildrenRouteStructure [];
}
export function bscReviewerRestriction (systemRole: string) {
  return systemRole === 'bsc-reviewer'
}

export const RouteStructure: IRouteStructure = {
  name: 'User Profile Main',
  path: '/user/:userOid/',
  component: () => import('@core/pages/userProfile/sections/v2/UserProfileV2.vue'),
  redirect: { name: 'User Profile' },
  children: [
    {
      name: 'User Profile',
      path: 'profile-summary/',
      pathToRegexpOptions: { strict: true },
      shouldDisabled: bscReviewerRestriction,
      component: () => import('@/views/userProfile/sections/UserProfileSummary.vue')
    },
    {
      path: 'adviser-details/',
      name: 'User Adviser Details',
      shouldDisabled: bscReviewerRestriction,
      component: () => import('@core/pages/userProfile/sections/v2/UserAdviserDetailsV2.vue')
    },
    {
      path: 'bsc-records/',
      name: 'User BSC Records',
      component: () => import('@core/pages/userProfile/sections/v2/UserBscRecordsV2.vue')
    },
    {
      path: 'cpd-records/',
      name: 'User CPD Records',
      shouldDisabled: bscReviewerRestriction,
      component: () => import('@core/pages/userProfile/sections/v2/UserCpdRecordsV2.vue')
    },
    {
      path: 'commission-statements',
      name: 'User Commission Statements',
      shouldDisabled: bscReviewerRestriction,
      component: () => import('@core/pages/CommissionModule/new-commission-module-components/UserCommissionStatements.vue')
    }
  ]
}
